import { Autocomplete, Checkbox, TextField } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useContext } from "react";
import { ExportRelatorioContext } from "../ExportRelatorioContext";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const Colunas = ({options}) => {
  const {colunas, setColunas} = useContext(ExportRelatorioContext)

  const allColunas = [{ variavel: "selecionarTodos", nome: "Selecionar Todos" }, ...options];
  
  const handleChangeAutoComplete = (_, value) => {
    const isSelecionarTodos = value?.some(
      (coluna) => coluna.variavel === "selecionarTodos"
    );

    if (isSelecionarTodos) {
      const isAllSelected = colunas.length === options.length;

      if (isAllSelected) {
        setColunas([]);
      } else {
        setColunas(options);
      }
    } else {
      setColunas(value ?? []);
    }
  };


  return (
    <div>
      <Autocomplete
        multiple
        options={allColunas || []}
        value={colunas}
        onChange={handleChangeAutoComplete}
        disableCloseOnSelect
        getOptionLabel={(option) => option.nome}
        fullWidth
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.nome}
            </li>
          );
        }}
        renderInput={(params) => <TextField {...params} label="Colunas" />}
      />
    </div>
  );
};

export default Colunas;
